module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("Home")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("About")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("Services")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("Contact")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48d7ceec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Lesson2/components/Sidebar.vue
// module id = 29
// module chunks = 0